<div class="table-emails">
	<div class="header-table">
		<div>
			<div class="buttons flex items-center">
				<button
					class="items-center mr-2"
					*ngIf="optionsFilter.length > 0"
					(click)="onClickSearch()"
					[ngClass]="{
						buttonTable: !showSearch,
						'buttonTable-active': showSearch
					}"
				>
					<mat-icon class="icon-material"> search </mat-icon>
					<span> {{ dataTranslate.buttonSearch }} </span>
				</button>
				<button *ngIf="isAdd" class="buttonTable items-center" (click)="onClickAction('add')">
					<mat-icon class="icon-material"> add </mat-icon>
					<span> {{ dataTranslate.buttonAdd }} </span>
				</button>
				<button
					class="buttonTable items-center"
					*ngIf="viewDelete"
					(click)="onClickAction('delete')"
				>
					<mat-icon class="icon-material"> delete </mat-icon>
					<span> {{ dataTranslate.buttonDelete }} </span>
				</button>
				<button
					class="buttonTable items-center"
					[disabled]="isDisabledRefresh"
					(click)="onClickAction('refresh')"
				>
					<mat-icon
						class="icon-material"
						[ngClass]="{
							'animate-spin': isRefresh
						}"
					>
						autorenew
					</mat-icon>
					<span> {{ dataTranslate.buttonRefresh }} </span>
				</button>
				<ng-content select="[slot='start']"></ng-content>
			</div>
		</div>

		<div class="content-pagination items-center flex">
			<ng-content class="buttonTable items-center" select="[slot='end']"> </ng-content>
		</div>
	</div>

	<div class="md:block bg-white">
		<div class="layout">
			<div
				class="layout__search"
				[ngClass]="{ 'filters-exit': !showSearch, view_aside: showSearch }"
				class="relative"
			>
				<div class="filter" [ngClass]="{ hidden: !showSearch, block: showSearch }">
					<app-filter
						[options]="optionsFilter"
						[widh]="widthFilter"
						(filterSelected)="filterSelectedValue($event)"
					></app-filter>
				</div>
			</div>
			<div [ngStyle]="calcHeigthTable(heigth)">
				<ng-content class="table" select="[table]"></ng-content>
				<ng-content class="table" select="[loading]"></ng-content>
			</div>
		</div>
	</div>
</div>
